// @flow
import React from 'react';
import type {Node} from 'react';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Box, Popover, Dialog} from '@wellstone-solutions/web';

type PropsType = {
  anchorEl: HTMLElement | null,
  onClose: () => void,
  children: Node,
};

export const FilterDialog = ({
  anchorEl,
  onClose,
  children,
}: PropsType): Node => {
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? (
    <Dialog fullScreen open={open} onClose={onClose}>
      <Box p={2}>{children}</Box>
    </Dialog>
  ) : (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      sx={{
        '& .MuiPopover-paper': {
          borderRadius: '20px',
          width: '400px',
        },
      }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 2,
        horizontal: 'right',
      }}>
      <Box p={2}>{children}</Box>
    </Popover>
  );
};
